function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $04e1f29f3d49c1bf$exports = {};
$04e1f29f3d49c1bf$exports = "<div class=\"navbar-container\"> <div class=\"navbar-container-inner\"> <div class=\"navbar-left\"> <div class=\"navbar-item\">All</div> <div class=\"active navbar-item\">Listed</div> <div class=\"navbar-item\">Private</div> </div> <div class=\"navbar-right\"> <div class=\"navbar-item\">Add to Collection</div> <div class=\"navbar-item\">Export Collection</div> </div> </div> </div>";


var $5451c824be1e98fe$exports = {};
$5451c824be1e98fe$exports = ".navbar-container{border-bottom:1px solid #e0e0e0;justify-content:space-between;width:100%;display:flex}.navbar-container-inner{justify-content:space-between;width:100%;display:flex}.navbar-left{flex:1;justify-content:flex-start;display:flex}.navbar-right{flex:1;justify-content:flex-end;display:flex}.navbar-item{color:var(--grey-400343434,#343434);letter-spacing:-.21px;margin-right:10px;padding-top:13px;padding-bottom:13px;font-family:Aktiv Grotesk Corp;font-size:14px;font-style:normal;font-weight:500;line-height:24px}.active{border-bottom:2px solid #0fa}.navbar-left .navbar-item{margin-left:48px}.navbar-left .navbar-item:first-child{margin-left:0}.navbar-right .navbar-item:last-child{margin-right:0}.navbar-right .navbar-item{margin-right:48px}";


const $746f8c36f8b2c37e$var$template = document.createElement("template");
$746f8c36f8b2c37e$var$template.innerHTML = `
<style>
${0, (/*@__PURE__*/$parcel$interopDefault($5451c824be1e98fe$exports))}
</style>
${0, (/*@__PURE__*/$parcel$interopDefault($04e1f29f3d49c1bf$exports))}
`;
class $746f8c36f8b2c37e$export$42cfbb80f7861e77 extends HTMLElement {
    static get observedAttributes() {
        return [];
    }
    constructor(){
        super();
        this.attachShadow({
            mode: "open"
        });
        this.shadowRoot.appendChild($746f8c36f8b2c37e$var$template.content.cloneNode(true));
    }
    connectedCallback() {}
    disconnectedCallback() {}
    attributeChangedCallback(name, oldValue, newValue) {}
}
customElements.define("my-navbar", $746f8c36f8b2c37e$export$42cfbb80f7861e77);


//# sourceMappingURL=index.b777ee96.js.map
